import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.137}
    height={16.752}
    {...props}
  >
    <defs>
      <style>{".cls-1{fill:#00446e}"}</style>
    </defs>
    <g id="noun-notification-4441744" transform="translate(-152.948 -28.005)">
      <path
        id="Path_222"
        data-name="Path 222"
        className="cls-1"
        d="M270.653 476h-3.723a.931.931 0 1 0 0 1.861h3.723a.931.931 0 1 0 0-1.861z"
        transform="translate(-109.294 -433.104)"
      />
      <path
        id="Path_223"
        data-name="Path 223"
        className="cls-1"
        d="m165.8 37.591-.717-1.433v-2.569a5.584 5.584 0 0 0-11.168 0v2.569l-.717 1.433a2.383 2.383 0 0 0 2.131 3.444h8.371a2.383 2.383 0 0 0 2.131-3.444z"
      />
    </g>
  </svg>
)

export default SvgComponent